import { cn } from '@/lib/utils'

interface PageContainerProps {
  children: React.ReactNode
  className?: string
  noPadding?: boolean
  allowOverflow?: boolean
}

export function PageContainer({
  children,
  className,
  noPadding = false,
  allowOverflow = false,
}: PageContainerProps) {
  return (
    <main className="relative flex flex-1 flex-col">
      <div
        className={cn(
          'mx-auto w-full max-w-4xl flex-1 bg-surface',
          !allowOverflow && 'overflow-hidden',
          allowOverflow && 'flow-root',
          !noPadding && 'px-4 py-4',
          'pb-6 sm:pb-4',
          className,
        )}
      >
        {children}
      </div>
    </main>
  )
}
